/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { googleAuthControllerCallback } from '../fn/google-auth/google-auth-controller-callback';
import { GoogleAuthControllerCallback$Params } from '../fn/google-auth/google-auth-controller-callback';
import { googleAuthControllerTriggerUserAuth } from '../fn/google-auth/google-auth-controller-trigger-user-auth';
import { GoogleAuthControllerTriggerUserAuth$Params } from '../fn/google-auth/google-auth-controller-trigger-user-auth';

@Injectable({ providedIn: 'root' })
export class GoogleAuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `googleAuthControllerCallback()` */
  static readonly GoogleAuthControllerCallbackPath = '/thalea-google-events/google-auth/callback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleAuthControllerCallback()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleAuthControllerCallback$Response(params: GoogleAuthControllerCallback$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return googleAuthControllerCallback(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleAuthControllerCallback$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleAuthControllerCallback(params: GoogleAuthControllerCallback$Params, context?: HttpContext): Observable<void> {
    return this.googleAuthControllerCallback$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `googleAuthControllerTriggerUserAuth()` */
  static readonly GoogleAuthControllerTriggerUserAuthPath = '/thalea-google-events/google-auth/{tenant}/{email}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `googleAuthControllerTriggerUserAuth()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleAuthControllerTriggerUserAuth$Response(params: GoogleAuthControllerTriggerUserAuth$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return googleAuthControllerTriggerUserAuth(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `googleAuthControllerTriggerUserAuth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  googleAuthControllerTriggerUserAuth(params: GoogleAuthControllerTriggerUserAuth$Params, context?: HttpContext): Observable<void> {
    return this.googleAuthControllerTriggerUserAuth$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
